import Immutable from 'immutable';

/**
 * Keys that may contain PII
 */
export const piiKeys = Immutable.Set([
  'name',
  'address',
  'unit',
  'city',
  'state',
  'zip',
  'email',
  'oemail'
]);

/**
 * Constructs a new object based on `input`, replacing
 *   any fields in {@link allPiiKeys} with `REDACTED`
 *
 * Key checking is case-insensitive
 *
 * @param {*} input - Item to generate redacted field
 *   set from.
 */
export const redactPiiFields = (input) => {
  if (!input || typeof input !== 'object') {
    return input;
  }
  return Object.keys(input).reduce((obj, key) => {
    if (piiKeys.has(key.toLowerCase())) {
      obj[key] = 'REDACTED';
    } else {
      obj[key] = input[key];
    }
    return obj;
  }, {});
};



// WEBPACK FOOTER //
// ./src/modules/pii-filter.js